import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import SendEmailService from './SendEmailService';

// Actions
const GET_USER_EVENTS = 'email/GET_USER_EVENTS';
const SEND_EMAIL = 'email/SEND_EMAIL';

const initialState = {
  userEvents: [],
  errorSendEmail: '',
  loadingEmail: false,
};

// Reducer
export default function sendEmailReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_USER_EVENTS:
      return {
        ...state,
        userEvents: action.result.data || [],
      }
    case SEND_EMAIL:
      return {
        ...state,
        loadingEmail: action.result.loading || initialState.loadingEmail,
        errorSendEmail: action.result.error || '',
      };
    default:
      return state;
  }
}


// Action Creators
export function getUserEventsAction(result) {
  return { type: GET_USER_EVENTS, result };
}

export function sendEmailAction(result) {
  return { type: SEND_EMAIL, result };
}

// Action dispatcher functions
export function getUserEvents(id) {
  return createDispatchFunction(
    partial(SendEmailService.getUserEvents, id),
    getUserEventsAction
  );
}

export function sendEmail(email) {
  return createDispatchFunction(
    partial(SendEmailService.sendEmail, email),
    sendEmailAction
  );
}
